var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-checkbox",class:{
    _large: _vm.size === 'large',
    _disabled: _vm.disabled,
  }},[_c('label',{staticClass:"base-checkbox__checker",class:{
      '_gray-1': _vm.viewType === 'gray-1',
      '_gray-2': _vm.viewType === 'gray-2',
      '_gray-3': _vm.viewType === 'gray-3',
      '_gray-3-1': _vm.viewType === 'gray-3-1',
      '_gray-4': _vm.viewType === 'gray-4',
      '_gray-5': _vm.viewType === 'gray-5',
      '_gray-6': _vm.viewType === 'gray-6',
      '_gray-7': _vm.viewType === 'gray-7',
      '_gray-8': _vm.viewType === 'gray-8',
      '_gray-9': _vm.viewType === 'gray-9',
      _disabled: _vm.disabled,
    }},[_c('div',{staticClass:"base-checkbox__checker__wrapper",class:{
        _large: _vm.size === 'large',
        _disabled: _vm.disabled,
      }},[_c('input',{ref:"checkbox",staticClass:"base-checkbox__checker__wrapper__input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateSelf($event.target.checked)}}}),_c('span',{staticClass:"base-checkbox__checker__wrapper__checkmark",class:{ '_half-checked': _vm.halfCheck }})]),(_vm.$slots.hasOwnProperty('default'))?_c('span',{staticClass:"base-checkbox__text"},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }